import { call, put, takeEvery, all } from 'redux-saga/effects';
import Store from '../../../Casadesk/Store/Store';
import Constants from "../../Action/Constants";
import Http from '../../Http/Http';
import { saveAs } from 'file-saver';
import Formatter from '../../Localization/Formatter';
import Translator from '../../Translation/Translator';
import Places from '../../API/Google/Places';
const XLSX = require("xlsx")

class DataSpreadSheet {
  protected trans(key: string, params: any = {}, locale: string = "", sendToLogger: boolean = true): string {
    if (!!Store.getConfigurator().getState().app.isLanguageKeySwitchOn) {
      return key;
    }
    return Translator.trans(!!key && key.toLowerCase(), params, locale, sendToLogger);
  }

  protected fitToColumn = (arrayOfArray) => {
    return arrayOfArray[0].map((_a, i) => ({ wch: Math.max(...arrayOfArray.map(a2 => (a2[i] || "").toString().length)) }));
  }

  protected getDataArray = (data, language) => {
    const dataArray = [];
    const titles = [
      Translator.trans("sheets-date"),
      Translator.trans("sheets-type"),
      Translator.trans("sheets-object"),
      Translator.trans("sheets-counterpart"),
      Translator.trans("sheets-description"),
      Translator.trans("sheets-amount-receivable"),
      Translator.trans("sheets-amount-payable"),
    ];
    
    dataArray.push(titles);
  
    data.forEach(item => {
      if (item.chargeTypeLabel === "Basic_rent" && item.amountPaid === 0) {
        return;
      }
      
      let amountReceivable = item.chargeClassLabel === 'Receivable'
      ? (item.amountPaid === 0 ? Formatter.simpleFormatNumberForReport(item.amount, true, true) : Formatter.simpleFormatNumberForReport(item.amountPaid, true, true))
      : '';

      let amountPayable = item.chargeClassLabel === 'Payable'
        ? (item.amountPaid === 0 ? Formatter.simpleFormatNumberForReport(item.amount, true, true) : Formatter.simpleFormatNumberForReport(item.amountPaid, true, true))
        : '';

      if (parseFloat(amountReceivable) === 0 || parseFloat(amountPayable) === 0) {
        return;
      }
    
      dataArray.push([
          Formatter.formatDateDependsOnLanguageForReport(new Date(item.createdAt), language),
          this.getTypeLabel(item),
          formatAddress(item.addressLine1, item.addressLine2) || item.addresseeName || item.name,
          item.name,
          item.description,
          amountReceivable,
          amountPayable,
      ]);
  });

  return dataArray;
  }

  protected saveBook = (s) => {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

  public getTypeLabel(item) {
    const type = Formatter.checkTranslationType(
      this.trans(item.chargeTypeLabel, {}, '', item?.type?.system),
      item.chargeTypeLabel,
      item?.type?.system)
    return type;
  }

  public download = (data, action) => {
    var dataSpreadSheet = XLSX.utils.book_new();

    dataSpreadSheet.SheetNames.push("Data");

    const dataArray = this.getDataArray(data, action.payload.lng);
    var sheetFromArrayData = XLSX.utils.aoa_to_sheet(dataArray);
    sheetFromArrayData['!cols'] = this.fitToColumn(dataArray);

    dataSpreadSheet.Sheets["Data"] = sheetFromArrayData;
    var book = XLSX.write(dataSpreadSheet, { bookType: "xlsx", type: "binary" });

    saveAs(
      new Blob([this.saveBook(book)], { type: "application/octet-stream" }),
      `${action.name}-${action.payload.year}.xlsx`
    );
  }
}

function formatAddress(addressLine1, addressLine2) {
  if (!addressLine1 && !addressLine2) {
      return null;
  }

  return [addressLine1, addressLine2].filter(Boolean).join(', ');
}

function* downloadCharges(action) {
  try {
      const response = yield call(Http.post, `charges/download/${action.payload?.year}/${action.payload?.ownerId}`, {}, { responseType: 'json' });
      action.name = response.data.name;
      if (response.data.updatedCharges && response.data.updatedCharges.length > 0) {
          const enrichedCharges = yield all(response.data.updatedCharges.map(charge => call(enrichChargeWithData, charge)));
          const spreadsheet = new DataSpreadSheet();
          spreadsheet.download(enrichedCharges, action);
      } else {
          yield put({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                  message: action.payload?.userlng === "en-US" ? "No charges found" : "Geen nota’s gevonden",
                  type: "error",
              },
          });
          yield put({
              type: Constants.GLOBAL_CHARGES_DOWNLOAD_FAILURE,
              payload: 'No data found',
          });
      }
  } catch(err) {
      console.error('Error downloading charges:', err);
      yield put({
          type: Constants.GLOBAL_CHARGES_DOWNLOAD_FAILURE,
          payload: err.message || 'Unknown error',
      });
  } 
}

function* enrichChargeWithData(charge) {
    try {
        const addressDetails = yield call(Places.getAddress, String(charge.addressId)) || null;
        const enrichedCharge = { ...charge, formattedAddress: addressDetails.formattedAddress };
        return enrichedCharge;
    } catch (error) {
        console.error('Error enriching charge with address data:', error);
        return charge;
    }
}



export function* watchDownloadCharges() {
    yield takeEvery(Constants.GLOBAL_CHARGES_DOWNLOAD_START, downloadCharges);
}
